import React from 'react';
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import WhySattvaLogo from "../../assets/images/bg/laptop.png";

const StartYourESGJourney = () => {
  return (
    <article className="min-h-[calc(100vh-100px)] flex flex-col items-center p-4 md:py-32 bg-gradient-to-b from-green-50/20 to-transparent dark:from-green-600/20 dark:to-[#0F172A]">
      <div className="container relative bg-gradient-to-br from-green-300 via-emerald-300 to-teal-300
          shadow-xl shadow-green-900/20 backdrop-blur-md p-6 md:p-12 rounded-2xl shadow-xl">
        <div className="grid md:grid-cols-12 grid-cols-1 gap-10 items-center container">

          {/* Left Image */}
          <div className="lg:col-span-6 md:col-span-6 flex justify-center md:justify-end relative">
            <motion.img
              src={WhySattvaLogo}
              className="lg:w-[480px] w-[300px] h-[300px] rounded-xl object-cover"
              alt="SATTVA ESG"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
            />
            {/* <motion.img
              src={WhySattvaLogo}
              className="absolute bottom-[-20px] left-0 lg:w-[120px] w-[60px] rounded-xl border-2 border-white/30 shadow-lg"
              alt="Accent"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
            /> */}
          </div>

          {/* Right Content */}
          <div className="lg:col-span-6 md:col-span-6 mt-4 md:mt-0">
            <h4 className="text-2xl md:text-3xl font-bold mb-2 dark:text-black">
              Start your ESG journey with <span className="text-blue-600">SATTVA</span>
            </h4>

            <p className="text-black/80 mb-2 text-sm md:text-base leading-relaxed">
              Talk to our team to see how SATTVA simplifies ESG management across your organization.
            </p>

            <ul className="list-disc list-inside text-black/90 space-y-2 mb-6 text-sm md:text-base">
              <li>
                Transition all your data from other systems to Plan A—done by our experts in weeks, not months.
              </li>
              <li>
                Rely on expert assistance for collecting, validating, and uploading data, ensuring sound and complete data.
              </li>
              <li>
                Stay on track with regular check-ins giving guidance on calculation methods, templates, and employee surveys.
              </li>
            </ul>

            <Link to="/contact">
              <button className="px-6 py-3 bg-blue-600 text-base hover:bg-blue-700 text-white rounded-full font-semibold shadow-lg transition-all duration-300 hover:shadow-xl">
                Book a demo
              </button>
            </Link>
          </div>

        </div>
      </div>
    </article>
  );
}

export default StartYourESGJourney;
